module.exports = __webpack_public_path__ + "img/government_icon.7e429be8.jpg";